import { SVGProps, FC } from 'react'

interface IProps extends SVGProps<SVGSVGElement> {}

const LocationMark: FC<IProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16699 6.76211C2.16699 3.4961 4.77033 0.833252 8.00033 0.833252C11.2303 0.833252 13.8337 3.4961 13.8337 6.76211C13.8337 8.33885 13.3843 10.0319 12.59 11.4945C11.7966 12.9553 10.6374 14.2247 9.18733 14.9025C8.43404 15.2546 7.56661 15.2546 6.81332 14.9025C5.36324 14.2247 4.20407 12.9553 3.4107 11.4945C2.61634 10.0319 2.16699 8.33885 2.16699 6.76211ZM8.00033 1.83325C5.33928 1.83325 3.16699 4.03157 3.16699 6.76211C3.16699 8.16016 3.56875 9.69019 4.28946 11.0172C5.01115 12.3461 6.03101 13.433 7.23676 13.9966C7.72169 14.2233 8.27896 14.2233 8.7639 13.9966C9.96965 13.433 10.9895 12.3461 11.7112 11.0172C12.4319 9.69019 12.8337 8.16016 12.8337 6.76211C12.8337 4.03157 10.6614 1.83325 8.00033 1.83325ZM8.00033 5.16658C7.1719 5.16658 6.50033 5.83816 6.50033 6.66658C6.50033 7.49501 7.1719 8.16658 8.00033 8.16658C8.82875 8.16658 9.50033 7.49501 9.50033 6.66658C9.50033 5.83816 8.82875 5.16658 8.00033 5.16658ZM5.50033 6.66658C5.50033 5.28587 6.61961 4.16658 8.00033 4.16658C9.38104 4.16658 10.5003 5.28587 10.5003 6.66658C10.5003 8.0473 9.38104 9.16658 8.00033 9.16658C6.61961 9.16658 5.50033 8.0473 5.50033 6.66658Z"
      />
    </svg>
  )
}

export default LocationMark
